import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TipoAndamentoService } from './tipo-andamento-service/tipo-andamento.service';

@Component({
  selector: 'app-tipo-andamento',
  templateUrl: './tipo-andamento.component.html',
  styleUrls: ['../tipo-evento/tipo-evento.component.css']
})
export class TipoAndamentoComponent implements OnInit {

  carregando = true;
  tipoAndamentos: any[] = [];
  display: boolean = false;
  nomeNovoTipoAndamento: string = '';

  displayConfirmarExclusao: boolean = false;
  tipoAndamentoParaExcluir: any = null;

  displayVinculos: boolean = false;
  carregandoVinculos: boolean = false;
  tipoAndamentoSelecionado: any = null;
  elementosDisponiveis: any[] = [];
  elementosVinculados: any[] = [];
  elementosDisponiveisFiltrados: any[] = [];
  elementosVinculadosFiltrados: any[] = [];
  alteracoesVinculos: boolean = false;
  termoPesquisaDisponiveis: string = '';
  termoPesquisaVinculados: string = '';

  constructor(
    private serviceTipoAndamento: TipoAndamentoService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.carregando = true;
    this.carregarTipoAndamentos();
  }

  showDialog() {
    this.display = true;
  }

  hideDialog() {
    this.display = false;
  }

  carregarTipoAndamentos() {
    this.carregando = true;
    this.tipoAndamentos = [];

    this.serviceTipoAndamento.getTipoAndamentos()
      .then((response: any) => {
        const dadosTipoAndamentos = Array.isArray(response?.data) ? response.data : response;

        if (dadosTipoAndamentos && Array.isArray(dadosTipoAndamentos)) {
          this.tipoAndamentos = dadosTipoAndamentos.map((tipoAndamento: any) => ({
            id: tipoAndamento.idTipoAndamento ?? tipoAndamento.id,
            nome: tipoAndamento.descAndamentoFab ?? tipoAndamento.descTipoAndamento ?? tipoAndamento.nome,
            vinculos: tipoAndamento.countVinculados ?? tipoAndamento.vinculos ?? 0,
            contemFabrica: !!(tipoAndamento.contemFabrica ?? tipoAndamento.contem_fabrica)
          }));
        }
        this.carregando = false;
      })
      .catch((error: any) => {
        this.carregando = false;
        console.error('Erro ao carregar tipos de andamento:', error);
        this.tratarErro(
          this.translate.instant('parametros.tipoAndamento.erroCarregarTipoAndamentos'),
          this.translate.instant('parametros.tipoAndamento.erro'),
          error
        );
      });
  }

  adicionarTipoAndamento(nomeTipoAndamento: string) {
    if (!nomeTipoAndamento || nomeTipoAndamento.trim() === '') {
      this.exibirErro(
        this.translate.instant('parametros.tipoAndamento.nomeObrigatorio'),
        this.translate.instant('parametros.tipoAndamento.erro')
      );
      return;
    }

    const tipoAndamentoExistente = this.tipoAndamentos.find(f =>
      f.nome.toLowerCase() === nomeTipoAndamento.toLowerCase()
    );

    if (tipoAndamentoExistente) {
      this.exibirErro(
        this.translate.instant('parametros.tipoAndamento.tipoAndamentoJaExiste'),
        this.translate.instant('parametros.tipoAndamento.erro')
      );
      return;
    }

    this.serviceTipoAndamento.adicionarTipoAndamento(nomeTipoAndamento.trim())
      .then(() => {
        this.exibirSucesso(
          this.translate.instant('parametros.tipoAndamento.tipoAndamentoAdicionado'),
          this.translate.instant('parametros.tipoAndamento.sucesso')
        );
        this.limparFormulario();
        this.hideDialog();
        this.carregarTipoAndamentos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoAndamento.erroAdicionarTipoAndamento'),
          this.translate.instant('parametros.tipoAndamento.erro'),
          error
        );
      });
  }

  private limparFormulario() {
    this.nomeNovoTipoAndamento = '';
  }

  removerTipoAndamento(idTipoAndamento: number) {
    const index = this.tipoAndamentos.findIndex(f => f.id === idTipoAndamento);
    if (index > -1) {
      const tipoAndamentoRemovido = this.tipoAndamentos[index];

      if (tipoAndamentoRemovido.vinculos > 0) {
        const mensagem = this.translate.instant('parametros.tipoAndamento.naoPodeRemoverComVinculos')
          .replace('{nome}', tipoAndamentoRemovido.nome)
          .replace('{vinculos}', tipoAndamentoRemovido.vinculos.toString());
        this.exibirErro(mensagem, this.translate.instant('parametros.tipoAndamento.avisoVinculosAtivos'));
        return;
      }

      this.tipoAndamentoParaExcluir = tipoAndamentoRemovido;
      this.displayConfirmarExclusao = true;
    }
  }

  confirmarExclusao() {
    if (!this.tipoAndamentoParaExcluir) return;

    this.serviceTipoAndamento.removerTipoAndamento(this.tipoAndamentoParaExcluir.id)
      .then(() => {
        this.exibirSucesso(
          this.translate.instant('parametros.tipoAndamento.tipoAndamentoRemovido'),
          this.translate.instant('parametros.tipoAndamento.sucesso')
        );
        this.hideDialogConfirmarExclusao();
        this.carregarTipoAndamentos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoAndamento.erroRemoverTipoAndamento'),
          this.translate.instant('parametros.tipoAndamento.erro'),
          error
        );
      });
  }

  hideDialogConfirmarExclusao() {
    this.displayConfirmarExclusao = false;
    this.tipoAndamentoParaExcluir = null;
  }

  verVinculos(tipoAndamento: any) {
    this.tipoAndamentoSelecionado = tipoAndamento;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
    this.carregandoVinculos = true;
    this.displayVinculos = true;
    this.carregarElementosVinculos(tipoAndamento.id);
  }

  carregarElementosVinculos(tipoAndamentoId: number) {
    this.serviceTipoAndamento.getVinculosTipoAndamento(tipoAndamentoId)
      .then((response: any) => {
        let dadosVinculos = response;

        if (response && response.data) {
          dadosVinculos = response.data;
        }

        if (!dadosVinculos) {
          dadosVinculos = {
            disponiveis: [],
            vinculados: []
          };
        }

        this.processarVinculosTipoAndamento(dadosVinculos);
        this.carregandoVinculos = false;
      })
      .catch((error: any) => {
        console.error('Erro ao carregar vínculos:', error);
        this.carregandoVinculos = false;
        this.tratarErro(
          this.translate.instant('parametros.tipoAndamento.erroCarregarVinculos'),
          this.translate.instant('parametros.tipoAndamento.erro'),
          error
        );
      });
  }

  private processarVinculosTipoAndamento(dadosVinculos: any) {
    this.elementosDisponiveis = (dadosVinculos.disponiveis || []).map((item: any, index: number) => ({
      id: `disp_${index}`,
      nome: item.descTipoAndamento,
      vinculado: false,
      contemFabrica: !!(item.contemFabrica ?? item.contem_fabrica)
    }));

    this.elementosVinculados = (dadosVinculos.vinculados || []).map((item: any, index: number) => ({
      id: `vinc_${index}`,
      nome: item.descTipoAndamento,
      vinculado: true,
      contemFabrica: !!(item.contemFabrica ?? item.contem_fabrica)
    }));

    this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  adicionarVinculo(elemento: any) {
    if (elemento.vinculado) return;

    const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosDisponiveis.splice(index, 1);
    }

    elemento.vinculado = true;
    this.elementosVinculados.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerVinculo(elemento: any) {
    const index = this.elementosVinculados.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosVinculados.splice(index, 1);
    }

    elemento.vinculado = false;
    this.elementosDisponiveis.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  filtrarElementosDisponiveis() {
    if (!this.termoPesquisaDisponiveis || this.termoPesquisaDisponiveis.trim() === '') {
      this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    } else {
      const termo = this.termoPesquisaDisponiveis.toLowerCase().trim();
      this.elementosDisponiveisFiltrados = this.elementosDisponiveis.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  filtrarElementosVinculados() {
    if (!this.termoPesquisaVinculados || this.termoPesquisaVinculados.trim() === '') {
      this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    } else {
      const termo = this.termoPesquisaVinculados.toLowerCase().trim();
      this.elementosVinculadosFiltrados = this.elementosVinculados.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  limparPesquisaDisponiveis() {
    this.termoPesquisaDisponiveis = '';
    this.filtrarElementosDisponiveis();
  }

  limparPesquisaVinculados() {
    this.termoPesquisaVinculados = '';
    this.filtrarElementosVinculados();
  }

  vincularTodosFiltrados() {
    if (this.elementosDisponiveisFiltrados.length === 0) return;

    const elementosParaVincular = [...this.elementosDisponiveisFiltrados];

    elementosParaVincular.forEach(elemento => {
      if (!elemento.vinculado) {
        const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
        if (index > -1) {
          this.elementosDisponiveis.splice(index, 1);
        }

        elemento.vinculado = true;
        this.elementosVinculados.push(elemento);
      }
    });

    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerTodosVinculos() {
    if (this.elementosVinculados.length === 0) return;

    this.elementosVinculados.forEach(elemento => {
      elemento.vinculado = false;
      this.elementosDisponiveis.push(elemento);
    });

    this.elementosVinculados = [];
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  salvarVinculos() {
    if (!this.alteracoesVinculos) return;

    this.serviceTipoAndamento.salvarVinculosTipoAndamento(
      this.tipoAndamentoSelecionado.id,
      this.elementosVinculados
    )
      .then(() => {
        this.tipoAndamentoSelecionado.vinculos = this.elementosVinculados.length;

        const tipoAndamentoIndex = this.tipoAndamentos.findIndex(
          f => f.id === this.tipoAndamentoSelecionado.id
        );
        if (tipoAndamentoIndex > -1) {
          this.tipoAndamentos[tipoAndamentoIndex].vinculos = this.elementosVinculados.length;
        }

        this.exibirSucesso(
          this.translate.instant('parametros.tipoAndamento.vinculosSalvos'),
          this.translate.instant('parametros.tipoAndamento.sucesso')
        );

        this.alteracoesVinculos = false;
        this.hideDialogVinculos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoAndamento.erroSalvarVinculos'),
          this.translate.instant('parametros.tipoAndamento.erro'),
          error
        );
      });
  }

  hideDialogVinculos() {
    this.displayVinculos = false;
    this.carregandoVinculos = false;
    this.tipoAndamentoSelecionado = null;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  trackByElemento(index: number, elemento: any): number {
    return elemento.id;
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  exibirErro(mensagem: string, titulo: string) {
    this.toastr.error(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    console.error(error);
    let msg: string;
    try {
      if (error.status === 401) {
        this.router.navigateByUrl('logout');
      }
      msg = mensagem + '\n' + error.erro;
    } catch (Exception) {
      msg = mensagem;
    }
    this.toastr.error(msg, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }
}
